import React from "react";
import useDragScroll from "../hooks/useDragScroll";
import aiTemplate from "../assets/sliderimage/ai.jfif";
import automation from "../assets/sliderimage/automation.jfif";
import dragDropEditor from "../assets/sliderimage/Drag-&-drop-editor.jfif";
import emailTemplates from "../assets/sliderimage/Email-templates.jfif";
import personalisation from "../assets/sliderimage/Personalisation.jfif";
import subscriberFields from "../assets/sliderimage/Subscriber-fields.jfif";
import tagsSegmentation from "../assets/sliderimage/Tags-and-segmentation.jfif";

const featureCards = [
  {
    id: 1,
    image: emailTemplates,
    title: "Email templates",
    text: "Layouts that are unique as your brand, ready to customise in minutes.",
    tone: "mint",
  },
  {
    id: 2,
    image: tagsSegmentation,
    title: "Tags and segmentation",
    text: "Keep subscribers organised so you can send the emails they want to receive.",
    tone: "pink",
  },
  {
    id: 3,
    image: subscriberFields,
    title: "Subscriber fields",
    text: "Ask subscribers anything, then use that data to personalise every email.",
    tone: "purple",
  },
  {
    id: 4,
    image: aiTemplate,
    title: "AI template",
    text: "Generate polished email templates with AI, then customise them for your brand.",
    tone: "cream",
  },
  {
    id: 5,
    image: personalisation,
    title: "Personalisation",
    text: "Dynamically personalise subject lines and content using subscriber data.",
    tone: "aqua",
  },
  {
    id: 6,
    image: dragDropEditor,
    title: "Drag & drop editor",
    text: "Build emails with images, buttons, text blocks, and code sections.",
    tone: "rose",
  },
  {
    id: 7,
    image: automation,
    title: "Automation",
    text: "Create journeys that respond to subscriber actions and save your team time.",
    tone: "violet",
  },
];

export default function Slider() {
  const dragScroll = useDragScroll({ loop: true, auto: true, speed: 0.34 });
  const sliderItems = [...featureCards, ...featureCards, ...featureCards];

  return (
    <section className="template-showcase feature-showcase-fluid" aria-label="Mailsnappy feature slider">
      <div className="feature-slider-shell draggable-carousel" {...dragScroll}>
        <div className="feature-slider-track">
          {sliderItems.map((item, index) => (
            <article className={`feature-slider-card feature-slider-card-${item.tone}`} key={`${item.id}-${index}`}>
              <div className="feature-slider-media">
                <img src={item.image} alt={`${item.title} feature preview`} loading="lazy" />
              </div>
              <div className="feature-slider-copy">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
